import { PARTICIPATION_SOURCES } from "@/data/council/public-hearings/participation-sources";
import { relativeDeadline } from "@/lib/public-hearings/deadline";

const SUBMISSION_FORM = PARTICIPATION_SOURCES.find(
  (s) => s.id === "phmc-public-submissions",
);
const SPEAKER_REG = PARTICIPATION_SOURCES.find(
  (s) => s.id === "phmc-speaker-registration",
);

// Action block anchored at the foot of the brief. Italic Garamond
// context line above the primary CTA pill (.ph-cta), with a secondary
// "register to speak" pill alongside. Reuses the row's `.ph-cta`
// grammar so the call to action reads the same in list and detail.
export function CompactParticipationStrip({
  publicSubmissionFormUrl,
  submissionDeadlineUtc,
}: {
  publicSubmissionFormUrl: string | null;
  submissionDeadlineUtc: string | null;
}) {
  const submissionsClosed = relativeDeadline(submissionDeadlineUtc).closed;
  const submitUrl = publicSubmissionFormUrl ?? SUBMISSION_FORM?.url;
  const submitLabel = publicSubmissionFormUrl
    ? "Submit a written brief"
    : "Open the submission form";

  return (
    <section
      aria-label="Participate in this hearing"
      className="ph-detail-action"
    >
      <p className="ph-detail-action-l">
        {submissionsClosed
          ? "Written submissions for this hearing have closed."
          : "Council reads every submission filed before the deadline."}
      </p>
      <div className="ph-detail-action-row">
        {!submissionsClosed && submitUrl && (
          <a
            href={submitUrl}
            target="_blank"
            rel="noreferrer"
            className="ph-cta"
            title="City of Calgary — public submission form"
          >
            {submitLabel} <span className="arr">→</span>
          </a>
        )}
        {SPEAKER_REG && (
          <a
            href={SPEAKER_REG.url}
            target="_blank"
            rel="noreferrer"
            className="ph-detail-action-secondary"
            title={`${SPEAKER_REG.title} — City of Calgary`}
          >
            Register to speak <span aria-hidden>↗</span>
          </a>
        )}
      </div>
      <p className="ph-detail-action-foot">
        {submissionsClosed
          ? "You can still register to speak in person or by phone at the hearing itself."
          : "Written submissions close 12 noon Calgary time, 8 days before the hearing."}
      </p>
    </section>
  );
}
